import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductVariantSpec',
  props: {
    label: { default: '' },
    textClasses: { default: '' },
    labelClasses: { default: '' },
    text: { default: '' },
    url: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { label: string, textClasses: string, labelClasses: string, text: string, url: string }



const hasMeaningfulText = computed<boolean>(() => {
    const hasMeaningfulText = props.text && props.text.length > 2 && props.text !== '-' && props.text !== '--';
    return hasMeaningfulText;
});

return { __sfc: true,props, hasMeaningfulText }
}

})